module.exports = __webpack_public_path__ + "media/assets_v3/images/user-panel/confirm-account-mobile-ee931168f4f25ca217b156169fe57a09.jpeg";